import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlSearchProps extends ControlTemplateProps {
    
}

export const ControlSearch: React.FC<ControlSearchProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="search" {...ComponentProps(props)} style={{ ...styles.search ?? styles.text ?? styles.input, ...props.style }} />        
    );
};